<script setup lang="ts">
import { useRegisterSW } from "virtual:pwa-register/vue";
import { watch } from "vue";
import { toast } from "vue-sonner";

/**
 * The service worker is registered with `registerType: "prompt"`, which means a
 * new build installs and then *waits* until the page tells it to take over.
 * Without this component nothing ever does, so an installed PWA keeps serving
 * the build it was opened with until every client is closed.
 *
 * Prompting rather than reloading on our own is deliberate: a silent reload in
 * the middle of a trick would cost the hand.
 */
const { needRefresh, updateServiceWorker } = useRegisterSW();

const TOAST_ID = "pwa-update";

watch(needRefresh, (ready) => {
	if (!ready) return;
	toast.info("A new version of Belot Masters is ready.", {
		id: TOAST_ID,
		// Stays until it is acted on: the point is that it is not missed.
		duration: Number.POSITIVE_INFINITY,
		action: {
			label: "Reload",
			// `true` sends SKIP_WAITING and reloads once the new worker is in control.
			onClick: () => void updateServiceWorker(true)
		}
	});
});
</script>

<template><span class="hidden" aria-hidden="true" /></template>
